export class FormatoGrafico {
  constructor(id: string, descricao: string) {
    this.id = id;
    this.descricao = descricao;
  }

  id: string;
  descricao: string;
}